const attribute = (
  <div style={{ color: "white", margin: "20px" }}>
    Icons made by{" "}
    <a
      style={{ color: "white" }}
      href="https://www.freepik.com"
      title="Freepik"
    >
      Freepik
    </a>{" "}
    from{" "}
    <a
      style={{ color: "white" }}
      href="https://www.flaticon.com/"
      title="Flaticon"
    >
      www.flaticon.com
    </a>
  </div>
);

export default attribute;

// const Container = styled.div`
//   color: "white";
// `;
